module.exports = __webpack_public_path__ + "7f4ce8e948fd5695fd99eb9629574cab.jpg";